// First, so the browser's one-time install offer is caught even if it fires
// before anything renders.
import { registerServiceWorker } from './lib/install.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { AuthProvider } from './lib/auth.js';
import './index.css';

registerServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('No #root element in index.html.');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      {/*
       * Opted into the two React Router v7 behaviors now, which silences their
       * console warnings and means the upgrade changes nothing: navigations run
       * in a transition (so a lazy page keeps the old screen up while its code
       * loads, rather than flashing a skeleton), and relative links inside
       * splat routes resolve the v7 way. No route here is a splat with
       * relative links, so the second is a no-op today.
       */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
